import {
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    Tooltip
} from "@material-ui/core";
import React, { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./pqIndexStyle";
import { selectAktuellerGrenzwertsatzTemp, selectSelectedTab, updateSelectedTabAll } from "./pqIndexSlice";
import ColorValues from "./colorTableCell";
import { selectKenngroesseWert } from "../../../features/filter/kenngroesseSlice";
import { selectMessstelleWertTemp, selectSliderTemp, selectMessstelleWert } from "../../../features/filter/messstellenFilterSlice";
import { selectStartDatumTemp } from "../../../features/filter/zeitSlice";
import { selectEndeDatum } from "../../datenvollstaendigkeit/datenvollstaendigkeitSlice";
import { kenngroesse, messstelle } from "../../../utils/apiTypes";
import { pqIndexResult } from "./pqIndexTypes";
import { getMessstelleKenngroesse, selectMessstelleKenngroesse } from "./messstelleTableSlice";
import { getKenngroesseDetailUW, selectKenngroesseDetailUw } from "./kenngroesseDetailTableSlice";
import { selectUwKenngroesse, selectUWKenngroesseListe, selectUWMinKenngroesseAll, selectUWMinKenngroesseListe, selectUwMinUwListe } from "./uwKenngroesseGruppeTableSlice";
import LegendePQIndex from "./legendePQIndex";

export default function UmspannwerkKenngroesseGrid(): ReactElement {

    const dispatch = useAppDispatch();
    const classes = {

        ...globalStyles(),
        ...useStyles()
    };

    const uwKenngrosse = useAppSelector(selectUwKenngroesse);
    const messstellenKenngroesse = useAppSelector(selectMessstelleKenngroesse);
    const kenngroesseDetailUw = useAppSelector(selectKenngroesseDetailUw)
    const kenngroesseListe = useAppSelector(selectUWKenngroesseListe);
    const minUwListe = useAppSelector(selectUwMinUwListe);
    const minKenngroesseListe = useAppSelector(selectUWMinKenngroesseListe);
    const minValueAll = useAppSelector(selectUWMinKenngroesseAll);

    const grenzwertsatz = useAppSelector(selectAktuellerGrenzwertsatzTemp);
    const messstelleFilterWertTemp = useAppSelector(selectMessstelleWertTemp);
    const pqIndexSlider = useAppSelector(selectSliderTemp);
    const startDatum = useAppSelector(selectStartDatumTemp);
    const endeDatum = useAppSelector(selectEndeDatum);

    const kenngroesseFilterWertCommitted = useAppSelector(selectKenngroesseWert);
    const messstelleFilterWertCommitted = useAppSelector(selectMessstelleWert);

    const selectedTab = useAppSelector(selectSelectedTab);

    function openMesstelleKenngroesseGrid(uw: string) {
        let isInMessstelleKenngroesseList = false;
        const messstelleFilteredListe: messstelle[] = [];
        for (let index = 0; index < messstelleFilterWertTemp.length; index++) {
            // eslint-disable-next-line security/detect-object-injection
            const element = messstelleFilterWertTemp[index];
            if (element.umspannwerk == uw) {
                messstelleFilteredListe.push(element)
            }
        }
        for (let index = 0; index < messstellenKenngroesse.length; index++) {
            // eslint-disable-next-line security/detect-object-injection
            if (uw == messstellenKenngroesse[index].uw) {
                isInMessstelleKenngroesseList = true;
            }
        }
        if (!isInMessstelleKenngroesseList) {
            dispatch(getMessstelleKenngroesse(messstelleFilteredListe, kenngroesseFilterWertCommitted, startDatum, endeDatum, pqIndexSlider[0], pqIndexSlider[1], grenzwertsatz, false, true, uw));
            dispatch(updateSelectedTabAll(uw + "kenngroesse", selectedTab));
        }
    }

    function openKenngroesseDetailUwGrid(kenngroesseKategorie: string) {

        const kenngroesseListe: kenngroesse[] = []
        let isInMessstelleKenngroesseList = false;

        kenngroesseFilterWertCommitted.forEach(kenngroesseEleme => {
            if (kenngroesseEleme.pqIndexKategorie == kenngroesseKategorie) {
                kenngroesseListe.push(kenngroesseEleme)
            }
        })

        for (let index = 0; index < kenngroesseDetailUw.length; index++) {
            // eslint-disable-next-line security/detect-object-injection
            if (kenngroesseKategorie == kenngroesseDetailUw[index].kenngroesse) {
                isInMessstelleKenngroesseList = true;
            }
        }
        if (!isInMessstelleKenngroesseList) {
            dispatch(getKenngroesseDetailUW(messstelleFilterWertCommitted, kenngroesseListe, startDatum, endeDatum, pqIndexSlider[0], pqIndexSlider[1], grenzwertsatz, true, false, kenngroesseKategorie));
            dispatch(updateSelectedTabAll(kenngroesseKategorie + "uw", selectedTab));
        }
    }

    function createTableCell(kwElem: string, rows: pqIndexResult[]) {
        const rowsMaxIndex = rows.length
        let rowsIndex = 0;
        const cellValue = 11;
        while (rowsMaxIndex > rowsIndex) {
            // eslint-disable-next-line security/detect-object-injection
            if (kwElem == rows[rowsIndex].col) {
                // eslint-disable-next-line security/detect-object-injection
                return (<ColorValues value={rows[rowsIndex].value} />)
            }
            rowsIndex += 1;
        }
        return (<ColorValues value={cellValue} />)
    }

    return (
        <React.Fragment>
            <Grid item md={12} style={{ textAlign: 'left', marginRight: "20px" }}>
                <div>
                    <LegendePQIndex />
                    <TableContainer component={Paper} style={{ height: '80vh' }}>
                        <Table aria-label="simple table" className={classes.table}>
                            <TableHead>
                                <TableCell className={classes.tableHeaderHorizontalLeftmost} >Umspannwerk / Kenngrößenkategorie</TableCell>
                                {kenngroesseListe.map((elem, index) => (
                                    <Tooltip title="Zeige die Werte für die dazugehörigen Kenngrößen." key={index}>
                                        <TableCell
                                            className={classes.tableHeaderHorizontalClickable}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => (
                                                openKenngroesseDetailUwGrid(elem)
                                            )}
                                        >{elem}
                                        </TableCell>
                                    </Tooltip>
                                ))}
                                <TableCell className={classes.tableHeaderHorizontalBlank} style={{ width: "20px" }} />
                                <TableCell className={classes.tableHeaderHorizontal}>Alle Umspannwerke</TableCell>
                            </TableHead>
                            <TableBody>
                                {uwKenngrosse.map((rows, index) => (
                                    <TableRow key={rows[0].row} >

                                        <Tooltip title="Zeige die Werte für die dazugehörigen Messstellen.">
                                            <TableCell
                                                style={{ cursor: "pointer" }}
                                                className={classes.tableHeaderVerticalClickable}
                                                component="th"
                                                scope="rows"
                                                onClick={() => (
                                                    openMesstelleKenngroesseGrid(rows[0].row)
                                                )}
                                            >{rows[0].row}</TableCell>
                                        </Tooltip>

                                        {kenngroesseListe.map((kwElem) =>
                                            createTableCell(kwElem, rows)
                                        )}
                                        <TableCell className={classes.tableCellBlank} style={{ width: "20px" }} />
                                        {/* eslint-disable-next-line security/detect-object-injection*/}
                                        <ColorValues value={minUwListe[index]} />
                                    </TableRow>
                                ))}
                                <TableRow >
                                    <TableCell />
                                </TableRow>
                                <TableRow >
                                    <TableCell style={{ width: "295px" }} component="th" scope="rows" className={classes.tableHeaderVertical}>Alle Kenngrößenkategorien</TableCell>
                                    {minKenngroesseListe.map((elem, index) => (
                                        <ColorValues value={elem} key={index} />
                                    ))}
                                    <TableCell className={classes.tableCellBlank} style={{ width: "20px" }} />
                                    <ColorValues value={minValueAll} />
                                </TableRow>

                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </Grid>
        </React.Fragment>
    );
}
